module.exports = __webpack_public_path__ + "img/suma.d25e8b55.gif";